//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './VersionClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export function versionUrl(): string {
  let url_ = getBaseUrl() + "/api";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let versionDefaultOptions: Omit<UseQueryOptions<string, unknown, string>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string, unknown, string>, 'queryFn'>> = {
};
export function getVersionDefaultOptions() {
  return versionDefaultOptions;
};
export function setVersionDefaultOptions(options: typeof versionDefaultOptions) {
  versionDefaultOptions = options;
}

export function versionQueryKey(): QueryKey;
export function versionQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'VersionClient',
      'version',
    ]);
}
export function __version(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.version(
axiosConfig    );
}

/**
 * Gets the version of the service.
 * @return A string representing the version.
 */
export function useVersionQuery<TSelectData = string, TError = unknown>(options?: Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useVersionQuery<TSelectData = string, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __version(context, axiosConfig) : __version,
    queryKey: versionQueryKey(),
    ...versionDefaultOptions as unknown as Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets the version of the service.
 * @return A string representing the version.
 */
export function setVersionData(queryClient: QueryClient, updater: (data: string | undefined) => string, ) {
  queryClient.setQueryData(versionQueryKey(),
    updater
  );
}

/**
 * Gets the version of the service.
 * @return A string representing the version.
 */
export function setVersionDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string | undefined) => string) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function errorUrl(): string {
  let url_ = getBaseUrl() + "/error";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let errorDefaultOptions: Omit<UseQueryOptions<string, unknown, string>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string, unknown, string>, 'queryFn'>> = {
};
export function getErrorDefaultOptions() {
  return errorDefaultOptions;
};
export function setErrorDefaultOptions(options: typeof errorDefaultOptions) {
  errorDefaultOptions = options;
}

export function errorQueryKey(): QueryKey;
export function errorQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'VersionClient',
      'error',
    ]);
}
export function __error(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.error(
axiosConfig    );
}

export function useErrorQuery<TSelectData = string, TError = unknown>(options?: Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useErrorQuery<TSelectData = string, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __error(context, axiosConfig) : __error,
    queryKey: errorQueryKey(),
    ...errorDefaultOptions as unknown as Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setErrorData(queryClient: QueryClient, updater: (data: string | undefined) => string, ) {
  queryClient.setQueryData(errorQueryKey(),
    updater
  );
}

export function setErrorDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string | undefined) => string) {
  queryClient.setQueryData(queryKey, updater);
}